
import { defineComponent, ref, watch, onMounted, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'

export default defineComponent({
    name: 'Pop',
    props: ['data'],
    setup (props, context) {

    }
})
